module.exports = {
  footerText: 'Copyright CIS Tech Ltd © 2022',
  // apiserver: 'https://panttenapi.datalibrary.io/api/',
  apiserver: 'https://delzapi.yottaerp.com/api/',
  // apiserver: 'http://127.0.0.1:8000/api/'

  loader: '/assets/images/logo.png'
}

